import React, { useMemo, useEffect } from "react";
import "./style.css";
import {CurrentBodyType} from "./CurrentBodyType";
import { useImagePreloader } from "../../../../hooks/useImagePreloader";

export const CurrentBodyTypeHook = (props) => {
  const { data } = props;
  
  // Define image options to match Image component defaults
  const imageOptions = {
    quality: 100,
    formatSize: 1
  };
  
  // Check if gender is selected
  const hasGender = data.gender === 'male' || data.gender === 'female';
  
  // 使用useMemo缓存图片列表，避免不必要的重新计算
  const bodyTypeList = useMemo(() => {
    // Return empty array if gender is not selected yet
    if (!hasGender) {
      return [];
    }
    
    if (data.gender === 'male') {
      return [{
        image: "/static/image/questionnaire/weight-loss/currentBodyType/male_skinny@3x.png" ,
        value: "skinny",
        title: "Skinny",
      },{
        image: "/static/image/questionnaire/weight-loss/currentBodyType/male_regular@3x.png",
        value: "regular",
        title: "Regular",
      },{
        image: "/static/image/questionnaire/weight-loss/currentBodyType/male_extra@3x.png",
        value: "extra",
        title: "Extra",
      }]
    } else {
      return [{
        image: "/static/image/questionnaire/weight-loss/currentBodyType/female_regular@3x.png",
        value: "regular",
        title: "Regular",
      },{
        image: "/static/image/questionnaire/weight-loss/currentBodyType/female_plump@3x.png",
        value: "plump",
        title: "Plump",
      },{
        image: "/static/image/questionnaire/weight-loss/currentBodyType/female_extra@3x.png",
        value: "extra",
        title: "Extra",
      }]
    }
  }, [data.gender, hasGender]);

  // 提取图片URL用于预加载
  const imageUrls = useMemo(() => {
    return bodyTypeList.map(item => item.image);
  }, [bodyTypeList]);

  // 使用图片预加载Hook，只有当有性别时才启用
  const { isAllLoaded, loadingImages } = useImagePreloader(imageUrls, hasGender, imageOptions);

  const getList = () => bodyTypeList;
  
  // Don't render if gender is not selected (avoid showing wrong gender images)
  if (!hasGender) {
    return null;
  }

  return (
      <CurrentBodyType
          {...props}
          getList={getList}
          isImagesLoaded={isAllLoaded}
          loadingImages={loadingImages}
      />
  );
};
